var _defs, _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnConstruccion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 80",
    role: "img",
    "aria-label": "En construcci\\xF3n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "barrera"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 92,
    height: 22,
    rx: 3
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 92,
    height: 22,
    rx: 3,
    fill: "#f5b400"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2c3e50",
    clipPath: "url(#barrera)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "26,18 38,18 26,40 14,40"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50,18 62,18 50,40 38,40"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74,18 86,18 74,40 62,40"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98,18 110,18 98,40 86,40"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 92,
    height: 22,
    rx: 3,
    fill: "none",
    stroke: "#2c3e50",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 40,
    width: 6,
    height: 28,
    fill: "#7f8c9a"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 40,
    width: 6,
    height: 28,
    fill: "#7f8c9a"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 68,
    width: 22,
    height: 5,
    rx: 1.5,
    fill: "#2c3e50"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 68,
    width: 22,
    height: 5,
    rx: 1.5,
    fill: "#2c3e50"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 12,
    r: 5,
    fill: "#e67e22"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 12,
    r: 5,
    fill: "#e67e22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnConstruccion);
export default __webpack_public_path__ + "static/media/en-construccion.51385d0b95787d3b464cc8fde666f26c.svg";
export { ForwardRef as ReactComponent };